var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26893 5.59593L8.26893 4.2691C8.26893 3.01591 7.25302 2 5.99983 2C4.74664 2 3.73073 3.01591 3.73073 4.26911L3.73073 5.59592L8.26893 5.59593ZM5.99983 0.500001C3.91822 0.500001 2.23073 2.18749 2.23073 4.26911L2.23073 6.08057C1.17989 6.14038 0.34619 7.01148 0.34619 8.07729L0.346189 13.5C0.346189 14.6046 1.24162 15.5 2.34619 15.5L9.65349 15.5C10.7581 15.5 11.6535 14.6046 11.6535 13.5L11.6535 8.0773C11.6535 7.01147 10.8198 6.14038 9.76893 6.08057L9.76893 5.59593L9.76893 4.2691C9.76893 2.18749 8.08145 0.500001 5.99983 0.500001ZM9.65349 7.5773L2.34619 7.5773C2.07005 7.5773 1.84619 7.80115 1.84619 8.07729L1.84619 13.5C1.84619 13.7762 2.07005 14 2.34619 14L9.65349 14C9.92964 14 10.1535 13.7762 10.1535 13.5L10.1535 8.0773C10.1535 7.80115 9.92963 7.5773 9.65349 7.5773ZM6.99986 9.84638C6.99986 9.29409 6.55215 8.84638 5.99986 8.84638C5.44758 8.84638 4.99986 9.29409 4.99986 9.84638L4.99986 11.7309L4.99986 12.7309L6.99986 12.7309L6.99986 11.7309L6.99986 9.84638Z",
    fill: "#8E99B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fa042143c0567699cc5bd08b3fd54526.svg";
export { ForwardRef as ReactComponent };